import styled, { css } from 'styled-components';
import Image from 'next/image';
import Link from 'next/link';
import { rem } from '~/src/helpers/rem-converter.helper';
import { mediaQuery } from '~/src/styles/mixins';
import { FONTS } from '~/src/styles/style-helpers/font-helper';
import { MAX_1679, MAX_1919, MAX_567, MAX_767, MIN_1920 } from '~/src/styles/tokens/break-points';
import { COLORS } from '~/src/styles/tokens/colors';
import { BORDER_RADIUS } from '~/src/styles/tokens/border-radius';

const textDecorationStyles = css`
    text-decoration: underline;
`;

export const ProductGroupContainer = styled.div<{ hasManyProducts: boolean; hasOneProduct: boolean; }>`
    position: relative;
    padding: ${(p) => (p.hasManyProducts ? rem(40) : rem(28))} ${rem(28)};
    max-width: ${rem(496)};
    height: fit-content;
    background-color: ${COLORS.backgroundPrimary};
    border-radius: ${BORDER_RADIUS.big16};
    flex-direction: column;
    cursor: pointer;

    &:hover {
        box-shadow: 0 8px ${rem(16)} 0 rgba(0, 0, 0, 0.08), 0 4px ${rem(24)} 0 rgba(0, 0, 0, 0.12);
        ${(p) => p.hasOneProduct && textDecorationStyles};
    }

    ${(p) => p && css`
        ${mediaQuery({ maxWidth: MAX_1919 }, css`
            padding: ${rem(p.hasManyProducts ? 40 : 24)} ${rem(24)};
            max-width: ${rem(510)};
        `,
    )};`};

    ${(p) => p && css`
        ${mediaQuery({ maxWidth: MAX_1679 }, css`
            max-width: ${rem(496)};
        `,
    )};`};

    ${(p) => p && css`
        ${mediaQuery({ maxWidth: MAX_767 }, css`
            padding: ${rem(p.hasManyProducts ? 40 : 16)} ${rem(16)};
        `,
    )};`};

    ${mediaQuery(
        { maxWidth: MAX_567 },
        css`
            width: 100%;
        `,
    )};
`;

export const ProductGroupHeader = styled.div<{ hasOneProduct: boolean; }>`
    display: flex;
    align-items: center;
    margin-bottom: ${(p) => (p.hasOneProduct ? 0 : rem(16))};
`;

export const ProductGroupName = styled.h5`
    ${FONTS.wide.medium.size20};

    ${mediaQuery(
        { minWidth: MIN_1920 },
        css`
            ${FONTS.wide.medium.size24};
        `,
    )};
`;

export const ProductList = styled.div`
    display: flex;
    flex-direction: column;
    padding-left: ${rem(36)};
`;

export const Product = styled(Link)`
    cursor: pointer;
    margin-bottom: ${rem(16)};
    ${FONTS.compact.regular.size17};
    color: ${COLORS.textLightPrimary};
    text-decoration: none;

    ${mediaQuery(
        { minWidth: MIN_1920 },
        css`
            ${FONTS.compact.regular.size20};
        `,
    )};

    &:hover {
        ${textDecorationStyles};
    }

    &:last-child {
        margin-bottom: 0;
    }
`;

export const LogoImage = styled(Image)`
    margin-bottom: ${rem(24)};
    width: 100%;
    height: 80%;
`;

export const SmallLogoContainer = styled.div`
    width: ${rem(24)};
    height: ${rem(24)};
    margin-right: ${rem(12)};
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Tag = styled.span`
    position: absolute;
    top: ${rem(16)};
    right: 0;
    width: fit-content;
    height: ${rem(24)};
    padding: 4px ${rem(12)};
    background: ${COLORS.iconLightPrimary};
    ${FONTS.compact.medium.size12};
    line-height: ${rem(16)};
    color: ${COLORS.textLightInverted};
    border-radius: ${rem(12)} 0 0 ${rem(12)};
`;
